<template>
  <van-empty v-if="list.length < 1" description="暂无推广" image="error" />

  <van-swipe lazy-render :show-indicators="false" @change="swipeChange">
    <van-swipe-item v-for="item in list" :key="item.DispatchId">
      <div
        v-if="!loading"
        class="poster flex flex-v flex-pack-center flex-align-center"
      >
        <div class="content">
          <div class="img-box">
            <van-image :src="item.base64" />
          </div>
        </div>

        <div style="padding-bottom: 60px; color: #999">(长按保存图片)</div>
      </div>
      <div
        v-if="loading"
        class="poster flex flex-v flex-pack-center flex-align-center"
      >
        <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
      </div>
    </van-swipe-item>
  </van-swipe>
  <van-tabbar v-if="list.length" class="tabbar" fixed>
    <ul class="indicator-box flex flex-align-center flex-pack-center">
      <li
        v-for="(item, key) in list.length"
        :key="key"
        :class="{ current: key === index }"
      ></li>
    </ul>
    <div class="title-box flex-1">
      <h2>{{ list.length && list[index].SurveyTitle }}</h2>
    </div>
  </van-tabbar>
  <canvas
    id="canvas"
    :height="height"
    style="display: none"
    :width="width"
  ></canvas>
  <div id="qrcode" ref="qrcode" class="qrcode" style="display: none"></div>
</template>
<script>
  import store from '@/store'
  import api from '@/api'
  import QRCode from 'qrcodejs2'
  export default {
    props: {
      tabActive: {
        type: String,
        default: '',
      },
      channel: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        list: [],
        width: 1100,
        height: 2000,
        loading: false,
        index: 0,
      }
    },
    // watch: {
    //   tabActive(val) {
    //     this.init(val)
    //   },
    // },
    created() {
      this.init()
    },
    methods: {
      async init(tabActive) {
        if (this.list.length || tabActive == 'a') return
        await this.getList()
        this.getItem(0)
      },
      async getItem(key) {
        const item = this.list[key]
        const url = await this.getUrl(item)
        await this.crateQrcode(url)
        if (!item.base64) {
          this.loading = true
          setTimeout(() => {
            this.drawImg(item)
          }, 500)
        }
      },
      swipeChange(key) {
        this.index = key
        this.getItem(key)
      },
      async drawImg(item) {
        var canvas = document.getElementById('canvas')
        var ctx = canvas.getContext('2d')
        // let sx = 73
        // let sy = 135

        let sx
        let sy
        if (item.QRCodeSize) {
          sx = item.QRCodeX
          sy = item.QRCodeY
        } else {
          sx = 73
          sy = 135
        }
        if (item.Poster) {
          // 画背景图
          this.width = 1100
          this.height = 2000

          const poster = await this.loadImg(api.FileHost + item.Poster)
          // ctx.drawImage(poster, 0, 0, 1100, 2000)

          ctx.drawImage(poster, 0, 0, this.width, this.height)

          // 画二维码白底
          ctx.fillStyle = '#fff'
          if (item.QRCodeSize) {
            // ctx.fillRect(
            //   sx * (1100 / 266),
            //   sy * (2000 / 553),
            //   (item.QRCodeSize + 10) * (1100 / 266),
            //   (item.QRCodeSize + 10) * (1100 / 266)
            // )
          } else {
            ctx.fillRect(sx - 15, sy - 15, 290, 290)
          }

          //   ctx.fillRect(
          //     sx * (1100 / 257),
          //     sy * (2000 / 546),
          //     (item.QRCodeSize + 10) * (1100 / 257),
          //     (item.QRCodeSize + 10) * (1100 / 257)
          //   )
          // } else {
          //   ctx.fillRect(sx - 15, sy - 15, 290, 290)
          // }
          // ctx.fillRect(58, 120, 290, 290)
        } else {
          this.width = 260
          this.height = 260
          sx = 0
          sy = 0
        }

        // 画qrcode
        const qrcode = this.$refs['qrcode'].querySelector('canvas')
        //alert(qrcode[0].outerHTML)
        //console.log(qrcode)
        const qr = await this.loadImg(qrcode.toDataURL('image/png'))
        if (item.QRCodeSize) {
          ctx.drawImage(
            qr,
            item.QRCodeX,
            item.QRCodeY,
            item.QRCodeSize,
            item.QRCodeSize
          )
        } else {
          ctx.drawImage(qr, sx, sy, 260, 260)
        }
        // ctx.drawImage(qr, sx, sy, 260, 260)
        // 画qrcode end
        item.base64 = canvas.toDataURL('image/jpeg')
        this.loading = false
      },
      loadImg(url) {
        return new Promise((resolve, reject) => {
          //添加外网图片
          var img = new Image()
          //设置图片跨域访问
          img.setAttribute('crossOrigin', 'anonymous')
          var objectURL = null
          if (
            url.match(/^data:(.*);base64,/) &&
            window.URL &&
            URL.createObjectURL
          ) {
            objectURL = URL.createObjectURL(this.dataURL2blob(url))
            url = objectURL
          }
          img.onload = function () {
            resolve(img)
          }
          img.onerror = (e) => {
            alert(JSON.stringify(e))
            reject(new Error('That image was not found.:' + url.length))
          }
          //使用外网图片
          img.src = url
        })
      },
      /* dataURL 转成 blob
       * @param dataURL
       * @return blob
       */
      dataURL2blob(dataURL) {
        let binaryString = atob(dataURL.split(',')[1])
        let arrayBuffer = new ArrayBuffer(binaryString.length)
        let intArray = new Uint8Array(arrayBuffer)
        let mime = dataURL.split(',')[0].match(/:(.*?);/)[1]
        for (let i = 0, j = binaryString.length; i < j; i++) {
          intArray[i] = binaryString.charCodeAt(i)
        }
        let data = [intArray]
        let result

        result = new Blob(data, { type: mime })

        return result
      },
      // 生成二维码
      crateQrcode(text) {
        this.$refs.qrcode.innerHTML = ''
        return new Promise((resolve, reject) => {
          const qr = new QRCode('qrcode', {
            width: 260,
            height: 260, // 高度
            text: text, // 二维码内容
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.L,
          })
          resolve(qr)
        })
      },
      async getList() {
        return store
          .dispatch('user/GetMarketingAll', {
            tenantId: (await store.getters['user/getTenant']).TenantId,
          })
          .then((data) => {
            this.list = data.Data
          })
      },
      async getUrl(item) {
        let url = ''
        const H5Url = await store.getters['system/getH5Url']
        const userInfo = store.getters['user/getUserInfo']
        let name = 'survey'
        //1=普通问卷 2=测评 3=直接成交单
        if (item.SurveyType == 2) {
          name = 'test'
        }
        url = `${H5Url}survey/#/${name}/dispatch/${item.DispatchId}?channelId=${userInfo.UserId}`
        // 服务卡券
        if (item.SurveyType == 101) {
          url = `${H5Url}service/#/home/bindService?packageId=${item.SurveyId}&channelId=${userInfo.UserId}`
        }
        return url
      },
    },
  }
</script>
<style lang="scss" scoped>
  .title-box {
    // position: fixed;
    // left: 0;
    // right: 0;
    // bottom: 50px;
    text-align: center;
    padding: 10px;
    font-size: 16px;
    line-height: 1.4;
    border-radius: 2px;
    color: #fff;
    h2 {
      font-weight: normal;
      font-size: 18px;
      margin: 0;
      line-height: 30px;
      height: 30px;
      overflow: hidden;
    }
  }
  .poster {
    width: 100%;
    height: 100%;
    min-height: 680px;
    object-fit: contain;
    box-sizing: border-box;
    background: #f5f5f5;
    img {
      width: auto;
      height: auto;
      display: block;
    }
  }
  .content {
    position: relative;
  }
  .tabbar {
    background: rgba(0, 0, 0, 0.25);
    &::after {
      border: none;
    }
  }
  .indicator-box {
    position: absolute;
    left: 0;
    right: 0;
    top: -16px;
    z-index: 1024;
    li {
      width: 6px;
      height: 6px;
      background: rgba($color: #fff, $alpha: 0.5);
      border-radius: 3px;
      margin: 0 3px;
      box-shadow: 0 0 6px rgba($color: #000, $alpha: 0.3);
      &.current {
        background: #b57e48;
      }
    }
  }
</style>
